import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  AddMarketingFlowStepPayload,
  MarketingFlowStep
} from "../../marketing.types";

export const requestAddMarketingFlowStep = async ({
  flowId,
  data
}: AddMarketingFlowStepPayload): Promise<MarketingFlowStep> => {
  return await instance.post(
    `${ApiRoutesMarketing.Flows}/${flowId}/steps`,
    data
  );
};
